export class CreateUser {
	name: string;
	surname: string;
	email: string;
	password: string;
	organization: string;
	roleId: number;

	constructor(other?: Partial<CreateUser>) {
		other && Object.assign(this, other);
	}
}
